import cc from 'classcat';
import { NAME } from './constants';

export const model = (state) => state[NAME];
export const getModifiers = (state, name) => state[NAME][name];
export const getClass = (state, name) => cc(state[NAME][name]);
